interface CropImageOptions {
  maxWidth: number;
  maxHeight: number;
  defaultMimeType: string;
  quality: number;
}

const defaults: CropImageOptions = {
  maxWidth: 600,
  maxHeight: 600,
  defaultMimeType: 'image/jpeg',
  quality: 0.8,
};

export const cropImage = async (imageFile: File, params?: Partial<CropImageOptions>): Promise<string> => {
  const {maxWidth, maxHeight, defaultMimeType, quality} = {...defaults, ...params};
  const blobURL = URL.createObjectURL(imageFile);
  const img = new Image();
  return new Promise<string>((resolve, reject) => {
    img.src = blobURL;
    img.onload = () => {
      URL.revokeObjectURL(img.src);
      const [newWidth, newHeight] = calculateSize(img, maxWidth, maxHeight);
      const canvas = document.createElement('canvas');
      canvas.width = newWidth;
      canvas.height = newHeight;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, newWidth, newHeight);
      resolve(canvas.toDataURL(imageFile.type ?? defaultMimeType, quality));
    };

    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      // Handle the failure properly
      reject('Cannot load image');
    };
  });
};

function calculateSize(img, maxWidth, maxHeight) {
  let width = img.width;
  let height = img.height;

  // calculate the width and height, constraining the proportions
  if (width > height) {
    if (width > maxWidth) {
      height = Math.round((height * maxWidth) / width);
      width = maxWidth;
    }
  } else {
    if (height > maxHeight) {
      width = Math.round((width * maxHeight) / height);
      height = maxHeight;
    }
  }
  return [width, height];
}
